import { connect } from "react-redux";
import DatesPicker, { PICKER_TYPE } from "../components/DatesPicker";
import { changePeriodFromSelect } from "../actions/stats";
import moment from "moment-timezone";
import React, { Component } from "react";
import "./PeriodDatesPickerContainer.css";
import statsConfigs from "../../../configs/stats";

const mapStateToProps = (state, ownProps) => {
  return {
    period: state.stats.period,
    periodToCompare: state.stats.periodToCompare,
    isLoading: state.stats.graphLoading,
    periods: state.stats.periods
  };
};

class PeriodDatesPickerContainer extends Component {
  state = {
    startRangeSelectedPeriodToCompare: false,
    startRangeSelectedDefaultPeriod: false,
    pickerTypeDefaultPeriod: PICKER_TYPE.INTERVAL,
    pickerTypePeriodToCompare: PICKER_TYPE.INTERVAL
  };
  onDateChange = ({ startDate, endDate, periodDesignation }) => {
    if (!endDate) return;
    if (!startDate) startDate = statsConfigs.startDateRef;
    return this.props.changePeriodFromSelect(
      [moment(startDate).startOf("day"), moment(endDate).endOf("day")],
      periodDesignation
    );
  };

  disabledDate(date, isSecondPeriod) {
    // return date && date > moment().endOf("day");

    return (
      (date && date > moment().endOf("day")) ||
      // empecher une selection posterieur à la periode par default
      (isSecondPeriod &&
        this.state.pickerTypePeriodToCompare === PICKER_TYPE.SPECIFIC &&
        date.format("YYYY-MM-DD") < moment(this.props.period[1]).format("YYYY-MM-DD")) ||
      // empecher une selection posterieure au début de period à comparer
      (!isSecondPeriod &&
        !this.state.startRangeSelectedDefaultPeriod &&
        Array.isArray(this.props.periodToCompare) &&
        this.state.pickerTypeDefaultPeriod === PICKER_TYPE.INTERVAL &&
        date.format("YYYY-MM-DD") > moment(this.props.periodToCompare[0]).format("YYYY-MM-DD")) ||
      // empecher une selection postérieure a la fin de la période à comparer
      (!isSecondPeriod &&
        this.state.startRangeSelectedDefaultPeriod &&
        Array.isArray(this.props.periodToCompare) &&
        this.state.pickerTypeDefaultPeriod === PICKER_TYPE.INTERVAL &&
        date.format("YYYY-MM-DD") > moment(this.props.periodToCompare[1]).format("YYYY-MM-DD")) ||
      (!isSecondPeriod &&
        Array.isArray(this.props.periodToCompare) &&
        this.state.pickerTypeDefaultPeriod === PICKER_TYPE.SPECIFIC &&
        date.format("YYYY-MM-DD") > moment(this.props.periodToCompare[1]).format("YYYY-MM-DD")) ||
      // empecher une selection antérieur au début de period par défault
      (isSecondPeriod && date.format("YYYY-MM-DD") < moment(this.props.period[0]).format("YYYY-MM-DD")) ||
      // empecher pour la fin de period à comparer une selection d'une date anterieur à la fin de la periode par default
      (this.state.startRangeSelectedPeriodToCompare &&
        isSecondPeriod &&
        date.format("YYYY-MM-DD") < moment(this.props.period[1]).format("YYYY-MM-DD"))
    );
  }

  render() {
    return (
      <div style={{ display: "flex", marginLeft: 5 }}>
        <div className="PeriodDatesPickerContainer">
          <DatesPicker
            period={this.props.period}
            pickerType={this.state.pickerTypeDefaultPeriod}
            onSelectPickerType={pickerType => {
              this.setState({ pickerTypeDefaultPeriod: pickerType });
            }}
            disabledDate={date => {
              return this.disabledDate(date);
            }}
            onChange={data => {
              this.onDateChange({ ...data, periodDesignation: "defaultPeriod" });
              this.setState({ startRangeSelectedDefaultPeriod: false });
            }}
            onCalendarChange={() => this.setState({ startRangeSelectedDefaultPeriod: true })}
            isLoading={this.props.isLoading}
          />
          {this.props.isComparing && (
            <DatesPicker
              period={this.props.periodToCompare}
              pickerType={this.state.pickerTypePeriodToCompare}
              disabledDate={date => {
                const isSecondPeriod = true;
                return this.disabledDate(date, isSecondPeriod);
              }}
              onChange={data => {
                this.onDateChange({ ...data, periodDesignation: "periodToCompare" });
                this.setState({ startRangeSelectedPeriodToCompare: false });
              }}
              onSelectPickerType={pickerType => {
                this.setState({ pickerTypePeriodToCompare: pickerType });
              }}
              onCalendarChange={data => {
                this.setState({ startRangeSelectedPeriodToCompare: true });
              }}
              isLoading={this.props.isLoading}
            />
          )}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, { changePeriodFromSelect })(PeriodDatesPickerContainer);



// WEBPACK FOOTER //
// src/modules/stats/containers/PeriodDatesPickerContainer.js